import { render, staticRenderFns } from "./PageHeaderUserMenu.vue?vue&type=template&id=3b26426e&scoped=true&"
import script from "./PageHeaderUserMenu.vue?vue&type=script&lang=js&"
export * from "./PageHeaderUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderUserMenu.vue?vue&type=style&index=0&id=3b26426e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b26426e",
  null
  
)

export default component.exports